import { render, staticRenderFns } from "./resource.vue?vue&type=template&id=78acd112&"
import script from "./resource.vue?vue&type=script&lang=js&"
export * from "./resource.vue?vue&type=script&lang=js&"
import style0 from "./resource.vue?vue&type=style&index=0&id=78acd112&prod&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports